import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
import {areaElementClasses, LineChart} from '@mui/x-charts/LineChart';
import axios from "axios";
import {useState, useEffect, useLayoutEffect} from 'react';
import { memo,useContext } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useAlert } from './useAlert';
import dayjs from "dayjs";
import Switch from '@mui/material/Switch';
import styles from '../css/CombinedGraph.module.css';
import {FormGroup} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Lottie from 'react-lottie';
import animationData from '../lotties/mylottie.json';
import useMediaQuery from '@mui/material/useMediaQuery';

import sprite from "../assets/svg/icon_sprite.svg"
import { useGrowSetup } from '../GrowSetupContext';
import { AuthContext } from "./signin/AuthContext";


function shouldComponentUpdate(nextProps, nextState)
  {
        if (nextProps.value != this.state.value) {
            this.setState({value : nextProps.value});
            return true;
        }
        return false;
  };

function AreaGradient({ color, id }) {
    return (
        <defs>
            <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stopColor={color} stopOpacity={0.5} />
                <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
        </defs>
    );
}

AreaGradient.propTypes = {
    color: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
};

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

function CombinedGraph(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {token, setToken } = useContext(AuthContext);
  const chartHeight = isSmallScreen ? 300 : 500;
  const [datas, setData] = useState([]);
  const [xaxis, setXaxis] = useState([]);
  const { grow_setup, setGrowSetup } = useGrowSetup();
    const [width, height] = useWindowSize();
    const [whiteList, setwhiteList] = useState({
        Abluft:['Abluft', false],
        Umluft:['Umluft', false],
        Licht:['Licht', false],
        Temperatur:['Temperatur', false],
        Temperatur_2:['Temperatur_2', false],
        Humidity:['Luftfeuchte', false],
        Humidity_2:['Luftfeuchte_2', false],
        Heizung:['Heizung', false],
        Co2:['Co2', false],
        Luftdruck:['Luftdruck', false],
        VPD:['VPD', false],

    });
  const showAlert = useAlert();
  var x = props.gauge_value;

  var xaxiss = [];
  if (props.gauge_value != undefined) {
    datas.push(props.gauge_value);
    xaxis.push(new Date());
  }


  const  fetchData = async (measure) =>{
    var data = []
    var yesterday = new Date();
    yesterday =  new Date(yesterday.setDate(yesterday.getDate() -1));
    var today = new Date();
    today =  new Date(props.time_to);
    yesterday =  new Date(props.time_from);
    if (today.getTime() < yesterday.getTime()) {
        var temp = yesterday;
        yesterday = today;
        today = temp;
    }
      try {
         axios.post('/get_all_measures_by_timedelta/', {  start_time: yesterday,
                                        end_time:  today,
                                        grow_setup_id: grow_setup,
                                        aggregation_level: '5m',
                                        measure: measure, },{
             withCredentials: true, // Include credentials in this request
              headers: {'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'Method': 'GET',
              },
            }).then(response => {
             if(!Object.keys(response.data).length){
                 setData([]);
                 setXaxis([]);
             }
             else{

           setData(response.data);
           setXaxis(response.data[Object.keys(response.data)[0]].xaxis);
             }
         });



      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {
    setGrowSetup(grow_setup);
    fetchData(props.measure);
  }, [grow_setup,props.time_from,props.time_to]);






  const labelColors = {
    up: 'success',
    down: 'error',
    neutral: 'default',
  };

const colorPalette = ["#b3d4ff"];



const measures = {
    "Abluft":["abluft","air"],
    "Umluft":["umluft","cycle"],
    "Licht":["licht","light_mode"],
    "Temperatur":["temperatur","thermostat"],
    "Temperatur_2":["temperatur_2","thermostat"],
    "Luftfeuchte": ["humidity","humidity_percentage"],
    "Luftfeuchte_2":["humidity_2","humidity_percentage"],
    "Heizung": ["heizung","mode_heat"],
    "Co2": ["co2","co2"],
    "Luftdruck": ["luftdruck","compress"],
    "VPD": ["vpd","compare_arrows"],
};

    const colors = {
        "abluft":"#b3d4ff",
        "umluft":"#d6924c",
        "licht": "#e6d800",
        "temperatur":"#50e991",
        "humidity":"#0bb4ff",
        "heizung": "#e60049",
        "co2": "#9b19f5",
        "luftdruck": "#ffa300",
        "vpd": "#dc0ab4",
    };

    const measure_colors = theme.palette.mode === 'dark'
  ? {
    "abluft":"#b3d4ff",
    "umluft":"#d6924c",
    "licht": "#e6d800",
    "temperatur":"#50e991",
    "humidity":"#0bb4ff",
    "heizung": "#e60049",
    "co2": "#9b19f5",
    "luftdruck": "#ffa300",
    "vpd": "#dc0ab4",
}
  : {
    "abluft":"#b3d4ff",
    "umluft":"#d6924c",
    "licht": "#e6d800",
    "temperatur":"#50e991",
    "humidity":"#0bb4ff",
    "heizung": "#e60049",
    "co2": "#9b19f5",
    "luftdruck": "#ffa300",
    "vpd": "#dc0ab4",
};


    const successVars = {
        '--color': '#4caf50',
        '--box-shadow': 'rgb(76, 175, 80, .16)',
        'background-image': 'none',
        'background-color': 'rgb(36 163 11)',
        'border': '1px solid black'
    };

    const defaultVars = {
        '--color': '#1976d2',
        '--box-shadow': 'rgb(25, 118, 210, .16)',
        'background-color': 'rgb(0 89 2)',
        'background-image': 'none',
        'border': '1px solid black'
    };


function handleChange(event,measure){
    var whitelistnew2  = {...whiteList};
    whitelistnew2[event.currentTarget.attributes["data-my-attribute"].value] = !whiteList[event.currentTarget.attributes["data-my-attribute"].value];
    setwhiteList({...whitelistnew2})
}

  const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
  const color = labelColors[props.trend];

  const trendValues = { up: '+25%', down: '-25%', neutral: '+5%' };
  var xaxis_fertig = []
  if (Object.keys(datas).length > 0){
    xaxis_fertig = [{data: datas[Object.keys(datas)[0]].xaxis, valueFormatter: (date: Date) => dayjs(date).format("MMM D HH:mm:ss"),scaleType: 'band',}];
  }
  const series_fertig =   Object.entries(datas).filter(([key, value]) => whiteList[key]).map((key) => ( {
          label: String(key[0]).charAt(0).toUpperCase()+String(key[0]).slice(1),
          showMark: false,
          data: key[1].data,
          yAxisId:  key[0] == 'co2' ? 'right-axis' : 'left-axis',
          color:  measure_colors[key[0]],
          area: ['heizung','licht','abluft'].includes(key[0]) ? true: false,
          //stack: ['heizung','licht','abluft'].includes(key[0]) ? 'total': '',
          curve: ['heizung','licht','abluft'].includes(key[0]) ? 'linear': '',
          id: key[0] == 'heizung' ? 'organic': key[0] =='licht' ? 'referral' : key[0]=='abluft' ? 'direct': key[0] ,
          //color: key[0] == 'heizung' ? 'green': key[0] =='licht' ? 'red' : key[0]=='abluft' ? 'blue': '' ,
      }));

  return (
    <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
        {isSmallScreen &&(
            <CardContent>
                <Box sx={{ width: window.innerWidth *0.8, height: window.innerHeight*0.4 }}>
                <LineChart
                xAxis={xaxis_fertig}
                series={series_fertig}
                tooltip={{ trigger: 'axis', formatter: (params) => `Wert: ${params[0].value}` }}
                width={window.innerWidth *0.8}
                showHighlight
                showTooltip
                grid={{  horizontal: true }}
                height={chartHeight}
                yAxis= {[{
                    id: 'left-axis',
                    scaleType: 'linear',
                    tickInterval: 10,
                    label: 'Left Axis',
                    max:100
                },
                {
                    id: 'right-axis',
                    scaleType: 'linear',
                    tickInterval: 500,
                    label: 'Co2 Axis',
                    stroke: 'rgba(38,255,0,0.29)',
                    max:10000
                },
                ]
                }
                leftAxis="left-axis"
                rightAxis="right-axis"
                sx={{
                    '& .MuiChartsAxis-root': {
                      stroke: theme.palette.text.primary,
                    },
                    '& .MuiChartsGrid-line': {
                      stroke: theme.palette.divider,
                    },
                    '& .MuiAreaElement-series-organic': {
                        fill: "url('#organic')",
                    },
                    '& .MuiAreaElement-series-referral': {
                        fill: "url('#referral')",
                    },
                    '& .MuiAreaElement-series-direct': {
                        fill: "url('#direct')",
                    },
                  }}

            >
                <AreaGradient color={'red'} id="organic" />
                <AreaGradient color={'yellow'} id="referral" />
                <AreaGradient color={'grey'} id="direct" />
            </LineChart>
                </Box>
                <Box>

                <FormGroup row>
                {Object.entries(measures).map(([label, [measureKey, icon]]) => {
                    const isActive = whiteList[measureKey];
                    return (
                    <Button
                        key={measureKey}
                        
                        size="medium"
                        onClick={handleChange}
                        data-my-attribute={measureKey}
                        sx={{
                        m: 1,
                        px: 2,
                        backgroundImage: "none",
                        backgroundColor: isActive
                            ? theme.palette.success.main
                            : theme.palette.mode === 'light'
                            ? '#e0e0e0' // dunkleres Grau für Light Mode
                            : theme.palette.action.disabledBackground, // wie bisher im Dark Mode
                        color: isActive
                        ? "whitesmoke"
                        : theme.palette.mode === 'light'
                            ? theme.palette.text.primary // dunkler Text im Light Mode
                            : theme.palette.text.disabled, // heller Text im Dark Mode
                        boxShadow: isActive ? 3 : 'none',
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': {
                            backgroundColor: isActive
                            ? theme.palette.success.main
                            : theme.palette.mode === 'light'
                                ? '#d5d5d5' // etwas dunkler beim Hover in Light Mode
                                : theme.palette.action.disabledBackground,
                        },
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        }}
                    >
                        <svg style={{ width: '24px', height: '24px', fill: theme.palette.mode ==='light' ? '#000000':'#ffffff' }}>
                        <use xlinkHref={`${sprite}#${icon}`} />
                        </svg>
                        {label}
                    </Button>
                    );
                })}
                </FormGroup>

                    <Lottie
                        options={defaultOptions}
                        height={400}
                        width={400}
                    />
                </Box>
                <Typography>{whiteList['Temperatur']}</Typography>
            </CardContent>
        )}
        
        {!isSmallScreen &&(
      <CardContent>
          <Box sx={{ width: Math.max(window.innerWidth *0.8,1700), height: window.innerHeight*0.8 }}>
            <LineChart
                xAxis={xaxis_fertig}
                series={series_fertig}
                tooltip={{ trigger: 'axis', formatter: (params) => `Wert: ${params[0].value}` }}
                width={window.innerWidth *0.8}
                showHighlight
                showTooltip
                grid={{  horizontal: true }}
                height={chartHeight}
                yAxis= {[{
                    id: 'left-axis',
                    scaleType: 'linear',
                    tickInterval: 10,
                    label: 'Left Axis',
                    max:100
                },
                {
                    id: 'right-axis',
                    scaleType: 'linear',
                    tickInterval: 500,
                    label: 'Co2 Axis',
                    stroke: 'rgba(38,255,0,0.29)',
                    max:10000
                },
                ]
                }
                leftAxis="left-axis"
                rightAxis="right-axis"
                sx={{
                    '& .MuiChartsAxis-root': {
                      stroke: theme.palette.text.primary,
                    },
                    '& .MuiChartsGrid-line': {
                      stroke: theme.palette.divider,
                    },
                    '& .MuiAreaElement-series-organic': {
                        fill: "url('#organic')",
                    },
                    '& .MuiAreaElement-series-referral': {
                        fill: "url('#referral')",
                    },
                    '& .MuiAreaElement-series-direct': {
                        fill: "url('#direct')",
                    },
                  }}

            >
                <AreaGradient color={'red'} id="organic" />
                <AreaGradient color={'yellow'} id="referral" />
                <AreaGradient color={'grey'} id="direct" />
            </LineChart>
          </Box>
          <Box>

          <FormGroup row>
                {Object.entries(measures).map(([label, [measureKey, icon]]) => {
                    const isActive = whiteList[measureKey];
                    return (
                    <Button
                        key={measureKey}
                        
                        size="medium"
                        onClick={handleChange}
                        data-my-attribute={measureKey}
                        sx={{
                        m: 1,
                        px: 2,
                        backgroundImage: "none",
                        backgroundColor: isActive
                            ? theme.palette.success.main
                            : theme.palette.mode === 'light'
                            ? '#e0e0e0' // dunkleres Grau für Light Mode
                            : theme.palette.action.disabledBackground, // wie bisher im Dark Mode
                        color: isActive
                        ? "whitesmoke"
                        : theme.palette.mode === 'light'
                            ? theme.palette.text.primary // dunkler Text im Light Mode
                            : theme.palette.text.disabled, // heller Text im Dark Mode
                        boxShadow: isActive ? 3 : 'none',
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': {
                            backgroundColor: isActive
                            ? theme.palette.success.main
                            : theme.palette.mode === 'light'
                                ? '#d5d5d5' // etwas dunkler beim Hover in Light Mode
                                : theme.palette.action.disabledBackground,
                        },
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        }}
                    >
                        <svg style={{ width: '24px', height: '24px', fill: theme.palette.mode ==='light' ? '#000000':'#ffffff' }}>
                        <use xlinkHref={`${sprite}#${icon}`} />
                        </svg>
                        {label}
                    </Button>
                    );
                })}
                </FormGroup>


          </Box>
      </CardContent>
        )}
    </Card>
  );
}

CombinedGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  interval: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  trend: PropTypes.oneOf(['down', 'neutral', 'up','blue','yellow','secondary','warning']).isRequired,
  value: PropTypes.string.isRequired,
  measure: PropTypes.string.isRequired
};

export default memo(CombinedGraph);
